<template>
  <div class="main-content">
    <!-- Header -->
    <div class="header bg-gradient-primary py-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <div class="container">
      <div class="header-body text-center mb-7">
        <div class="row justify-content-center">
          <div class="col-xl-12 col-lg-12 col-md-12 px-5">
            <h1 class="text-lead text-white">
              {{ $t('page_not_found_title') }} 404
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: 'page_not_found.title',
  name: "PageNotFound",
  mounted() {
    document.body.classList.add("bg-default");
  }
};
</script>

<style scoped></style>
